import { render, staticRenderFns } from "./sjbz.vue?vue&type=template&id=4141d42a&scoped=true&"
import script from "./sjbz.vue?vue&type=script&lang=js&"
export * from "./sjbz.vue?vue&type=script&lang=js&"
import style0 from "./sjbz.vue?vue&type=style&index=0&id=4141d42a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4141d42a",
  null
  
)

export default component.exports